// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';

const ResultsInnovationComponent = ({ item, theme = 'teal', wrap = false }) => {
    // ///////////////////
    // DATA
    // ///////////////////

    const { Description__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            <ResultsInnovationDetails {...{ item, theme }} />
        </Card.CardContentWrapper>
    );
};

const ResultsInnovationDetails = ({ item, theme }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object, getValueLabel } = useLabels();

    // ///////////////////
    // DATA
    // ///////////////////

    const { Innovation_Type__c, URL__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {/* Various Info */}
            {[Innovation_Type__c, URL__c].some(x => x) && (
                <Card.CardContentPairBox>
                    {Innovation_Type__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Innovation_Type__c'
                                ),
                                value: getValueLabel(
                                    'Initiative_Result__c.Innovation_Type__c',
                                    Innovation_Type__c
                                ),
                            }}
                        />
                    )}
                    {URL__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.URL__c'
                                ),
                                value: URL__c,
                            }}
                        />
                    )}
                </Card.CardContentPairBox>
            )}
        </>
    );
};

ResultsInnovationComponent.propTypes = {
    item: t.object,
};

ResultsInnovationComponent.defaultProps = {};

export { ResultsInnovationDetails };
export default ResultsInnovationComponent;
